import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const STEPS = [
  "Fetching live Binance candles...",
  "Computing RSI & Stoch RSI...",
  "Detecting swings & S/R clusters...",
  "Classifying supports vs resistances...",
  "Handing structured data to the ChartLenz engine...",
  "Building the trade plan...",
];

/**
 * MarketAnalyzingView — visible while POST /market-analysis/analyze runs.
 * Text is deliberately different from the screenshot flow so users understand
 * this is a LIVE MARKET analysis, not a chart-reading pass.
 */
export default function MarketAnalyzingView({ symbol, timeframe }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % STEPS.length), 1400);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="pt-8 md:pt-10 max-w-5xl mx-auto" data-testid="market-analyzing">
      <div className="text-center mb-6">
        <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#00E5FF] mb-3">
          ── live market · analyzing ──
        </div>
        <h2 className="text-3xl sm:text-4xl font-black tracking-tighter text-white">
          Reading {symbol} <span className="text-neutral-500">{timeframe}</span>
        </h2>
        <p className="text-sm text-neutral-400 mt-2">
          Preprocessing 1,200 candles from Binance Spot before the engine runs.
        </p>
      </div>

      <div className="relative border border-neutral-900 bg-neutral-950 overflow-hidden h-56">
        <motion.div
          className="scan-line"
          initial={{ top: 0 }}
          animate={{ top: "100%" }}
          transition={{ duration: 2.2, repeat: Infinity, ease: "linear" }}
        />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(180deg, rgba(0,229,255,0.05) 0%, transparent 50%, rgba(0,229,255,0.05) 100%)",
          }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-neutral-600">
            binance spot → chartlenz engine
          </div>
        </div>
      </div>

      <div className="mt-6 border border-neutral-900 bg-neutral-950 p-4">
        <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-neutral-500 mb-2">
          engine log
        </div>
        <div
          className="font-mono text-sm text-neutral-200 terminal-caret"
          data-testid="market-analyzing-status"
        >
          {STEPS[idx]}
        </div>
        <div className="mt-3 h-1 bg-neutral-900 overflow-hidden">
          <motion.div
            className="h-full bg-[#00E5FF]"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 20, ease: "linear" }}
          />
        </div>
      </div>
    </section>
  );
}
